import { Group, Input } from "@mantine/core";
import { IMaskInput } from "react-imask";
import { VDN_MASK } from "@/shared-types";

export const VDN_MASK_PLACEHOLDER = "###-####";

interface VdnInputProps {
    value: string;
    onChange: (vdn: string) => void;
}

export function VdnInput({ value, onChange }: VdnInputProps) {
    return (
        <Group gap="xs" wrap="nowrap" w="100%">
            <Input
                component={IMaskInput}
                mask={VDN_MASK}
                value={value}
                onAccept={(value) => onChange(value)}
                placeholder={VDN_MASK_PLACEHOLDER}
            />
        </Group>
    );
}
